var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { axiosInstance } from '@/api/realApi/_axios';
import { joinUrl } from '@/api/realApi/_utils';
import { getCsrfHeaders } from '@/api/realApi/authApi';
const BOARDS_URL_PATH = '/api/boards/';
export const boardApi = {
    getBoardByCode: (boardCode) => __awaiter(void 0, void 0, void 0, function* () {
        const res = yield axiosInstance.get(joinUrl([BOARDS_URL_PATH, boardCode]));
        return res.data;
    }),
    list: (createdById) => __awaiter(void 0, void 0, void 0, function* () {
        const res = yield axiosInstance.get(BOARDS_URL_PATH, {
            params: {
                created_by: createdById,
            },
        });
        return res.data['results'] || res.data;
    }),
    create: (boardTitle, code) => __awaiter(void 0, void 0, void 0, function* () {
        const config = yield getCsrfHeaders();
        const payload = { title: boardTitle };
        if (code) {
            payload.code = code;
        }
        const res = yield axiosInstance.post(BOARDS_URL_PATH, payload, config);
        return res.data;
    }),
    update: (code, data) => __awaiter(void 0, void 0, void 0, function* () {
        const config = yield getCsrfHeaders();
        const res = yield axiosInstance.patch(joinUrl([BOARDS_URL_PATH, code]), data, config);
        return res.data;
    }),
    delete: (code) => __awaiter(void 0, void 0, void 0, function* () {
        const config = yield getCsrfHeaders();
        yield axiosInstance.delete(joinUrl([BOARDS_URL_PATH, code]), config);
    }),
    createSnapshot: (code_1, state_1, ...args_1) => __awaiter(void 0, [code_1, state_1, ...args_1], void 0, function* (code, state, label = '') {
        const config = yield getCsrfHeaders();
        const res = yield axiosInstance.post(joinUrl([BOARDS_URL_PATH, code, 'snapshots']), { state, label }, config);
        return res.data;
    }),
    listSnapshots: (code) => __awaiter(void 0, void 0, void 0, function* () {
        const res = yield axiosInstance.get(joinUrl([BOARDS_URL_PATH, code, 'snapshots']));
        return res.data;
    }),
    restoreSnapshot: (code, snapshotId) => __awaiter(void 0, void 0, void 0, function* () {
        const config = yield getCsrfHeaders();
        const res = yield axiosInstance.post(joinUrl([BOARDS_URL_PATH, code, 'restore']), { snapshot_id: snapshotId }, config);
        return res.data;
    }),
    reorderPresentationElements: (code, elements) => __awaiter(void 0, void 0, void 0, function* () {
        const config = yield getCsrfHeaders();
        const res = yield axiosInstance.post(joinUrl([BOARDS_URL_PATH, code, 'reorder_presentation_elements']), elements, config);
        return res.data;
    }),
};
